import { FC } from 'react'
import { OrderDetailTitleContainer, OrderDetailTitleLeftContent } from '../order.styled'
import { useTranslation } from 'react-i18next'

export const OrderDetailTitle: FC = () => {
  const { t } = useTranslation()

  return (
    <OrderDetailTitleContainer>
      <OrderDetailTitleLeftContent>
        <span>{t('Purchase details')}</span>
      </OrderDetailTitleLeftContent>
    </OrderDetailTitleContainer>
  )
}
